import { trackKnownAnalyticsEvent } from "../analyticsClient";
import {
  buildRecsysItemClickParams,
  buildRecsysItemLastViewParams,
  buildRecsysItemListViewParams,
  buildRecsysItemServeParams,
  buildRecsysRequestParams,
  buildRecsysSectionLastViewParams,
  buildRecsysSectionListViewParams,
  buildRecsysSectionServeParams,
  buildRecsysSectionViewAllParams,
  RecsysItemClickParamsInput,
  RecsysItemLastViewParamsInput,
  RecsysItemListViewParamsInput,
  RecsysItemServeParamsInput,
  RecsysRequestParamsInput,
  RecsysSectionLastViewParamsInput,
  RecsysSectionListViewParamsInput,
  RecsysSectionServeParamsInput,
  RecsysSectionViewAllParamsInput,
} from "../params/recsys";

export function trackRecsysRequest(params: RecsysRequestParamsInput): void {
  trackKnownAnalyticsEvent("recsys_request", buildRecsysRequestParams(params));
}

export function trackRecsysSectionServe(
  params: RecsysSectionServeParamsInput,
): void {
  trackKnownAnalyticsEvent(
    "recsys_section_serve",
    buildRecsysSectionServeParams(params),
  );
}

export function trackRecsysSectionListView(
  params: RecsysSectionListViewParamsInput,
): void {
  trackKnownAnalyticsEvent(
    "recsys_section_list_view",
    buildRecsysSectionListViewParams(params),
  );
}

export function trackRecsysSectionLastView(
  params: RecsysSectionLastViewParamsInput,
): void {
  trackKnownAnalyticsEvent(
    "recsys_section_last_view",
    buildRecsysSectionLastViewParams(params),
  );
}

export function trackRecsysSectionViewAll(
  params: RecsysSectionViewAllParamsInput,
): void {
  trackKnownAnalyticsEvent(
    "recsys_section_view_all",
    buildRecsysSectionViewAllParams(params),
  );
}

export function trackRecsysItemServe(params: RecsysItemServeParamsInput): void {
  trackKnownAnalyticsEvent(
    "recsys_item_serve",
    buildRecsysItemServeParams(params),
  );
}

export function trackRecsysItemListView(
  params: RecsysItemListViewParamsInput,
): void {
  trackKnownAnalyticsEvent(
    "recsys_item_list_view",
    buildRecsysItemListViewParams(params),
  );
}

export function trackRecsysItemLastView(
  params: RecsysItemLastViewParamsInput,
): void {
  trackKnownAnalyticsEvent(
    "recsys_item_last_view",
    buildRecsysItemLastViewParams(params),
  );
}

export function trackRecsysItemClick(params: RecsysItemClickParamsInput): void {
  trackKnownAnalyticsEvent("recsys_item_click", buildRecsysItemClickParams(params));
}
